module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_292.5deg.70cf145d.png";